import React from "react";
import Header from "../Home/header/Header";
import Cover from "./cover/Cover";
import Icons from "./Icons/Icons";
import Section from "./sectionContent/Section";
import Section4 from "../Home/section4/Section4";
import Footer from "../Home/footer/Footer";

function Technology() {
  return (
    <div>
      <Header />
      <Cover />
      <Icons />
      <Section />
      <Section4 />
      <Footer />
    </div>
  );
}

export default Technology;
